export interface Ringtone {
  start(): void;
  stop(): void;
}

type AudioContextLike = {
  destination: AudioNode;
  createOscillator(): OscillatorNode;
  createGain(): GainNode;
  close(): Promise<void> | void;
};

export function createRingtone(factory?: () => AudioContextLike): Ringtone {
  let ctx: AudioContextLike | null = null;
  let osc: OscillatorNode | null = null;

  return {
    start() {
      if (ctx) return;
      ctx = factory ? factory() : new AudioContext();
      osc = ctx.createOscillator();
      const gain = ctx.createGain();
      gain.gain.value = 0.05;
      osc.frequency.value = 440;
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start();
    },
    stop() {
      if (!ctx) return;
      try {
        osc?.stop();
      } catch {
        /* already stopped */
      }
      void ctx.close();
      ctx = null;
      osc = null;
    },
  };
}
